import { render } from "./DetilAbsensi.vue?vue&type=template&id=9a2ce768"
import script from "./DetilAbsensi.vue?vue&type=script&lang=js"
export * from "./DetilAbsensi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__